import React from 'react';
import { Button } from "react-bootstrap";

const Row = ({ partner, onRemove }) => {
    return (<tr>
        <td>{partner.name}</td>
        <td>{partner.auth}</td>
        <td>
            <Button bsStyle="danger" onClick={() => onRemove(partner.id)}>Remove</Button>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiPartners/components/Table/components/Row/index.js